const routerArr = [{
        path: 'asideMessaging',
        component: (resolve) => require(["page/asideMessageMangement/messaging/index"], resolve),
        meta: { show: '1110', title: '消息应用', source: '11b8' }
    },
    {
        path: 'messageTemplate',
        component: (resolve) => require(["page/asideMessageMangement/messageTemplate/index"], resolve),
        meta: { show: '1110', title: '消息模板', source: '11b8' ,keepAlive: true,keepPath:"/home/messageTemplate"}
    },
    {
        path: 'messageTemplate/addEditDetail',
        component: (resolve) => require(["page/asideMessageMangement/messageTemplate/addEditDetail"], resolve),
        meta: { show: '1110', title: '消息模板新增', source: '11b8',keepPath:"/home/messageTemplate" }
    },
    {
        path: 'messageGrounp',
        component: (resolve) => require(["page/asideMessageMangement/messageGrounp/index"], resolve),
        meta: { show: '1110', title: '消息群发', source: '11b8' },

    },
    // {
    //     path: 'housesGether/buildDetail',
    //     component: (resolve) => require(["page/workMangement/housesGether/buildDetail"], resolve),
    //     meta: { show: '1110', title: '楼栋信息详情', source: '11b8' }
    // },
    // {
    //     path: 'housesGether/cMessageDetail',
    //     component: (resolve) => require(["page/workMangement/housesGether/cMessageDetail"], resolve),
    //     meta: { show: '1110', title: '楼盘信息详情', source: '11b8' }
    // },
    // {
    //     path: 'housesGether/cCoordDetail',
    //     component: (resolve) => require(["page/workMangement/housesGether/cCoordDetail"], resolve),
    //     meta: { show: '1110', title: '楼盘坐标详情', source: '11b8' }
    // },




];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/asideMessageMangement/_res.js